import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import { Toaster } from "@/components/ui/sonner";
import Layout from "@/components/Layout";
import Home from "@/pages/Home";
import Listings from "@/pages/Listings";
import ListingDetail from "@/pages/ListingDetail";
import SubmitListing from "@/pages/SubmitListing";
import VerifyListing from "@/pages/VerifyListing";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import DashboardOwner from "@/pages/DashboardOwner";
import DashboardSearcher from "@/pages/DashboardSearcher";
import Admin from "@/pages/Admin";
import SearchByUse from "@/pages/SearchByUse";
import Editorial from "@/pages/Editorial";
import Contact from "@/pages/Contact";

function Protected({ children, admin = false }) {
  const { user, loading } = useAuth();
  if (loading) return <div className="min-h-screen flex items-center justify-center text-zinc-400 font-mono-tech text-xs tracking-widest">CHARGEMENT...</div>;
  if (!user) return <Navigate to="/login" replace />;
  if (admin && user.role !== "admin") return <Navigate to="/" replace />;
  return children;
}

function App() {
  return (
    <div className="App grain">
      <AuthProvider>
        <BrowserRouter>
          <Layout>
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/annonces" element={<Listings />} />
              <Route path="/annonces/:id" element={<ListingDetail />} />
              <Route path="/deposer" element={<SubmitListing />} />
              <Route path="/verifier" element={<VerifyListing />} />
              <Route path="/recherche-par-usage" element={<SearchByUse />} />
              <Route path="/proprietaires" element={<Editorial page="owners" />} />
              <Route path="/exploitants" element={<Editorial page="operators" />} />
              <Route path="/quel-usage" element={<Editorial page="usage" />} />
              <Route path="/a-propos" element={<Editorial page="about" />} />
              <Route path="/contact" element={<Contact />} />
              <Route path="/login" element={<Login />} />
              <Route path="/register" element={<Register />} />
              <Route path="/dashboard" element={<Protected><DashboardOwner /></Protected>} />
              <Route path="/mes-recherches" element={<Protected><DashboardSearcher /></Protected>} />
              <Route path="/admin" element={<Protected admin><Admin /></Protected>} />
              <Route path="*" element={<Navigate to="/" replace />} />
            </Routes>
          </Layout>
          <Toaster theme="dark" position="bottom-right" />
        </BrowserRouter>
      </AuthProvider>
    </div>
  );
}

export default App;
